export const HASH_FEATURES = "#hash_features";
export const HASH_SCENARIOS = "#hash_scenarios";
export const HASH_API = "#hash_api";
export const HASH_PRICING = "#hash_pricing";
export const HASH_CONTACT = "#hash_contact";
